import { gql } from '@apollo/client'

export const CASE_QUERY = gql`
  query m2Case($id: ID!, $isAdmin: Boolean = false) {
    m2Case(id: $id) {
      identifier
      canCreateAkte
      conflictPartnerFileNumber
      conflictPartnerNotNamed
      externalRsv
      forwardedCase
      disputeValueCalculationDescription
      coverageScope
      id
      createdAt
      claimDate
      claimDateDeprecated
      source
      handoverType
      comments
      conversationUrl
      jurnodesIdentifier
      jurnodesLastSyncedAt
      documents {
        url
        filename
        contentType
        pageCount
      }
      hint
      language
      commentsPolicyholder
      commentsLegalAdvice
      insuranceId
      insurance {
        title
        policyNumberRegex
      }
      projectId
      invoices {
        id
        invoiceNo
        sentAt
        documentUrl
        financeStatus
        financeStatusUpdatedAt
        financeInvoiceUrl
        processing {
          id
          costsSettledWithRsvAt
          rsvBillable
          rsvNonBillableReason
          cost
          costsCoveredByKp
          receivedPayment
          additionalCost
          income
          additionalIncome
          additionalIncomeComments
          processingStep
        }
      }
      project {
        title
        smsFromName
        smsText
        requestCostCoverageAvailable
        rightmartForwardingAvailable
        costCoverageEmail
        interface
        invoicingAfterFirstCall
        closeableOnFirstCall
        callCenterLegalAdvice
        aiEnabled
        collisionDetectionEnabled
        clientPayment
        refundAvailable
        policyNumberRegex
        policyNumberMask
        claimNumberRegex
        claimNumberMask
        jurnodesSyncEnabled
        additionalIncomeBillable
        invoiceFieldRequirements {
          id
          fieldName
          requirementType
          fieldLabel
        }
        withLeadingClaimNumber
        closingInfoEmail
      }
      caseState
      rsvStatus
      policyholder {
        id
        policyNumber
        salutation
        emailSalutation
        lastname
        firstname
        birthDate
        company
        street
        houseNumber
        postalCode
        place
        country
        phoneNumber
        mobileNumber
        email
        comments
        communicationViaCustomerPortal
        lastSignInAt
        firstSignInAt
        cases {
          id
          project {
            title
          }
          comments
          caseState
          claimNumber
          assignedToM2At
          policyholder {
            name
            firstname
            lastname
            policyNumber
          }
          rsvLegalArea {
            title
          }
          processings {
            actualProcessingType {
              category
              title
            }
            assignedProcessingType {
              title
              category
            }
          }
        }
        casesWithSameEmail {
          id
          project {
            title
          }
          comments
          caseState
          claimNumber
          assignedToM2At
          policyholder {
            name
            firstname
            lastname
            policyNumber
          }
          processings {
            actualProcessingType {
              title
              category
            }
            assignedProcessingType {
              title
              category
            }
          }
          rsvLegalArea {
            title
          }

          comments
        }
      }
      conflictPartner {
        id
        salutation
        lastname
        firstname
        birthDate
        company
        street
        houseNumber
        postalCode
        place
        country
        phoneNumber
        mobileNumber
        email
        comments
      }
      conflictContact {
        id
        salutation
        lastname
        firstname
        birthDate
        company
        street
        houseNumber
        postalCode
        place
        country
        phoneNumber
        mobileNumber
        email
        comments
        relationToConflictPartner
      }
      contactPerson {
        salutation
        id
        lastname
        firstname
        phoneNumber
        mobileNumber
        email
        relationToPolicyholder
      }
      claimNumber
      claimDate
      assignedToM2At
      m2LegalAreaId
      rsvLegalAreaId
      disputeValue
      creatorComments
      creatorId
      creator {
        id
        name
      }
      cost @include(if: $isAdmin)
      additionalCost @include(if: $isAdmin)
      customerComments @include(if: $isAdmin)
      settlementComments @include(if: $isAdmin)
      customerRating @include(if: $isAdmin)
      deductible
      deductibleAmount
      costsSettledWithRsvAt @include(if: $isAdmin)
      evaluatedDailyAt
      evaluatedMonthlyAt
      statusReportSentAt @include(if: $isAdmin)
      smsLogs
      paymentContacts {
        contactType
        salutation
        firstname
        lastname
        email
      }
      processings {
        poolId
        fileNumber
        deletable
        paymentRequestCost
        paymentRequestCostSource
        assignedFromId
        assignedFrom {
          id
          name
        }
        finalReportUrl
        finalReportSentAt
        feedbackRsvAt
        feedbacks {
          id
          feedbackReason
          feedbackCategory
          feedbackTypeId
          feedbackType {
            id
          }
          feedbackReceivedAt
          feedbackClosedAt
          feedbackChannel
          comments
          additionalComments
          feedbackValid
          sourceOfFeedback
          origin
          possibleSolution
          feedbackResolved
          closeFeedbackAction {
            closingResultDetail
            resultId
            result {
              id
              title
              systemValue
              parentResultId
              parentResult {
                id
                title
                systemValue
              }
            }
          }
        }
        invoice @include(if: $isAdmin) {
          id
          invoiceNo
          invoiceDate
          invoiceSum
          paidDeductible
          sumCosts
          agentId
          agent {
            id
            name
          }
          sentAt
          documentUrl
          financeStatus
          financeStatusUpdatedAt
          financeInvoiceUrl
          canceledAt
          consultantExportAt
          cancellable
        }
        customerInvoice {
          id
          invoiceNo
          agentId
          agent {
            id
            name
          }
          sentAt
          documentUrl
          financeStatus
          financeStatusUpdatedAt
          financeInvoiceUrl
          dataset
        }
        income
        incomeWithTax
        totalPayments
        totalRefunds
        refundAmount
        refundRequired
        refunded
        payoutStatus
        payoutAddedAt
        paymentStatus
        payments {
          id
          amount
          amountDecimal
          refundAmount
          refundAmountDecimal
          processingId
          email
          status
          refundStatus
          stripeCheckoutUrl
          paymentRequestedAt
          paymentReceivedAt
          reminderSentAt
          firstname
          lastname
          salutation
          createdAt
          updatedAt
        }
        paymentProtocols {
          id
          processingId
          activityType
          activityTypeLabel
          amountNetto
          amountBrutto
          fullname
          email
          createdAt
        }
        additionalIncome
        additionalIncomeComments
        invoiceSettlementComments
        costsSettledWithRsvAt
        rsvBillable
        rsvNonBillableReason
        additionalCost
        id
        caseEmailAddress
        coverage
        processingState
        costFromActualProcessingType
        agentId
        agent {
          id
          name
          birthDate
          houseNumber
          place
          postalCode
          street
        }
        involvedUsers {
          id
          name
        }
        assignedAt
        canBeginAt
        acceptedAt
        firstCallAt
        forwardedToRightmartAt
        closedAt
        closedByM2
        intendedProcessingTypeId
        documentsWereSent
        settlementRate
        settlementTypeId
        closingTypeId
        result
        closingResultId
        closingResult {
          id
          title
          systemValue
          processingResult
        }
        closedByRsv
        agentFit
        alternativeProcess
        coverageComments
        costsSettledWithOperatorAt @include(if: $isAdmin)
        cost @include(if: $isAdmin)
        additionalCost @include(if: $isAdmin)
        costsCoveredByKp @include(if: $isAdmin)
        receivedPayment @include(if: $isAdmin)
        settlementComments @include(if: $isAdmin)
        date1
        date2
        coverageRequestedAt
        policyholderContactedAt
        closingComments
        actualProcessingType {
          callCenterLegalAdvice
        }
        actualProcessingTypeId
        assignedProcessingTypeId
        assignedProcessingType {
          category
          title
          intern
          accessibleFor
          feedback
        }
        statusReportSentAt @include(if: $isAdmin)
        lastActionAt
        nextTaskAt
        nextTaskComment
        canBeginAt
        firstCallDelayed
        forwardedToRightmartAt
        goalPolicyholderWants
        goalPolicyholderSolutions
        goalConflictPartnerWants
        goalConflictPartnerSolutions
        processingComments
        contactAttemptSmsLogs
        m2Case {
          identifier
          forwardedCase
          claimDate
          conflictPartnerFileNumber
          disputeValue
          comments
          hint
          insuranceId
          insurance {
            title
          }
          projectId
          project {
            closeableOnFirstCall
            callCenterLegalAdvice
            collisionDetectionEnabled
            policyNumberRegex
            policyNumberMask
            claimNumberRegex
            claimNumberMask
            closingInfoEmail
          }
          policyholder {
            policyNumber
            salutation
            emailSalutation
            firstname
            lastname
            email
            phoneNumber
            mobileNumber
            lastSignInAt
            communicationViaCustomerPortal
            postalCode
            place
          }
          conflictPartner {
            salutation
            firstname
            lastname
            email
            phoneNumber
            mobileNumber
            postalCode
            place
            street
            houseNumber
            company
            salutation
          }
          conflictContact {
            firstname
            lastname
            salutation
            email
            phoneNumber
            mobileNumber
            relationToConflictPartner
          }
          conflictPartnerNotNamed
          contactPerson {
            firstname
            lastname
            salutation
            email
            phoneNumber
            mobileNumber
            relationToPolicyholder
          }
          m2LegalArea {
            title
            costsCoveredByKpActivePerDefault
          }
        }
      }
    }
  }
`
